import { Checkbox } from "@mui/material";
import { theme as defaultTheme } from "@mindlercare/ui-web";
import { styled } from "styled-components";
import {
  DialogContentWrapperScrollable,
  DialogContentWrapperStatic,
  DialogHeaderTextContainer,
  Row,
} from "components/lib/customModal/customModal.styles";
import CustomModal from "../../lib/customModal";

export const RowCenter = styled(Row)`
  justify-content: center;
  gap: 10px;
`;

export const CheckboxBlack = styled(Checkbox)`
  color: ${defaultTheme.COLORS.GRAY};

  &:not(.Mui-disabled)&.Mui-checked {
    color: ${({ theme }) => defaultTheme.COLORS.ACTION_BLUE};
  }

  &.Mui-disabled&.Mui-checked {
    color: ${({ theme }) => defaultTheme.COLORS.ACTION_BLUE};
    opacity: 0.5;
  }
`;

export const BodyText = styled.p`
  font-size: ${({ theme }) => defaultTheme.FONT.SIZE.STANDARD};
  margin: 0;
  color: ${defaultTheme.COLORS.GRAY_BLACK};
  white-space: pre-wrap;
`;

export const TextAreaBody = styled.div`
  border: 1px solid ${defaultTheme.COLORS.MIDDLE_GREY};
  padding: 15px;
  border-radius: 8px;
  max-width: 436px;
  flex: 1;
`;

export const TextWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 48px;
  border: 1px solid ${defaultTheme.COLORS.MIDDLE_GREY};
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 24px;
`;

export const BottomContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;

  button:last-of-type {
    margin-left: 10px;
  }
`;

export type ButtonProps = { variant: "primary" | "secondary"; ml?: number };

export const ActionButton = styled.button<ButtonProps>`
  cursor: pointer;
  position: relative;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  display: flex;
  padding: 0 40px;
  height: 40px;
  border: 1px solid ${({ theme }) => defaultTheme.COLORS.MIDDLE_GREY};
  font-family: ${({ theme }) => defaultTheme.FONT.FAMILY.BODY};
  font-weight: ${({ theme }) => defaultTheme.FONT.WEIGHT.MEDIUM};
  font-size: ${({ theme }) => defaultTheme.FONT.SIZE.SMALL_MEDIUM};
  border-radius: 20px;
  transition: 0.2s ease-in-out;
  color: ${({ variant, theme }) =>
    variant === "primary"
      ? defaultTheme.COLORS.WHITE
      : defaultTheme.COLORS.GRAY_BLACK};
  background-color: ${({ variant, theme }) =>
    variant === "primary"
      ? defaultTheme.COLORS.MEDIUM_GREEN
      : defaultTheme.COLORS.WHITE};

  &:hover {
    background-color: ${({ variant, theme }) =>
      variant === "primary"
        ? defaultTheme.COLORS.GREEN_HOVER
        : defaultTheme.COLORS.MEDIUM_GREEN_OPACITY};
    transition: 0.3s ease-in-out;
    border: 1px solid ${({ theme }) => defaultTheme.COLORS.MEDIUM_GREEN};
  }
`;

export const QuestionnaireModal = styled(CustomModal.Wrapper)`
  flex: 1;
  overflow-y: hidden;
  .DialogContainer {
    overflow-y: hidden;
  }
  .MuiDialog-paperScrollPaper {
    max-width: 50vw;
    height: 100%;
    max-height: 80%;
  }
  ${DialogContentWrapperStatic} {
    overflow-y: auto;
    padding: 0px;
    display: flex;
    flex-direction: column;
  }
  ${DialogHeaderTextContainer} {
    max-width: none;
  }
`;

export const QuestionnaireContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const QuestionnaireTextArea = styled(TextAreaBody)`
  border: 0;
  margin: 0;
  padding: 0;
  max-width: 100%;
  flex: 1;
`;

export const QuestionnaireScoringArea = styled(QuestionnaireTextArea)`
  font-size: ${({ theme }) => defaultTheme.FONT.SIZE.SMALL_MEDIUM};
  display: flex;
  flex-direction: column;
  line-height: 17px;
  padding-left: 48px;
  padding-right: 48px;
  padding-top: 24px;
  padding-bottom: 24px;
  background-color: ${({ theme }) => defaultTheme.COLORS.TERTIARY_LIGHT};
`;

export const CheckboxRow = styled(Row)`
  align-items: center;
  flex-wrap: nowrap;

  &:hover {
    text-decoration: underline;
    cursor: pointer;
    background-color: ${({ theme }) => defaultTheme.COLORS.GRAY_X_LIGHT};
  }
`;

export const QuestionnaireRowText = styled.p`
  font-family: "Rubik";
  font-style: normal;
  font-weight: ${({ theme }) => defaultTheme.FONT.WEIGHT.REGULAR};
  font-size: ${({ theme }) => defaultTheme.FONT.SIZE.SMALL_MEDIUM};
  line-height: 19px;
  color: ${({ theme }) => defaultTheme.COLORS.GRAY_BLACK};
  margin-top: 2px;
`;

export const QuestionnaireSubRowText = styled(QuestionnaireRowText)<{
  bold?: boolean;
}>`
  font-size: ${({ theme }) => defaultTheme.FONT.SIZE.SMALL};
  line-height: 14px;
  color: ${({ theme }) => defaultTheme.COLORS.GRAY_BLACK};
  margin-top: 2px;
  margin-bottom: 0px;
  font-weight: ${({ bold, theme }) =>
    bold ? defaultTheme.FONT.WEIGHT.BOLD : defaultTheme.FONT.WEIGHT.REGULAR};
`;

export const QuestionnaireContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 40px;
  flex-grow: 1;
`;

export const NewStyledQuestionnaireModal = styled(CustomModal.Wrapper)`
  width: 0%;

  ${DialogContentWrapperScrollable} {
    padding-top: 0;
  }

  ${DialogContentWrapperStatic} {
    padding: 0px;
    display: flex;
    width: 20%;
    flex-direction: column;
    height: calc(
      100% - 76px
    ); // magic 76px (height of title), can be fisked when container queries supported in Firefox
  }

  .MuiDialog-container {
    width: 704px;
  }

  .MuiDialog-paperScrollPaper {
    max-height: 100%;
    overflow-y: visible;
    width: 100%;
    max-width: 704px;
    border-radius: 0px;
  }
`;

export const NewAcceptButton = styled(CustomModal.Button)`
  :disabled {
    background-color: ${({ theme }) => defaultTheme.COLORS.PRIMARY};
    opacity: 0.3;
  }
`;
